const calculateSelectedMonth = (month: string): number => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;

  if (Number(month) - currentMonth >= 0) return 0;

  return Number(month) - currentMonth;
};

export default calculateSelectedMonth;
